import React, { useCallback, useState, useEffect, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
// import LineItem from '../sales/Pages/SalesInvoiceMaster/LineItem';
import LineItem from 'components/LineItem';
import BillTerm from '../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';
import ExchangeModal from '../sales/Pages/SalesInvoiceMaster/ExchangeModal';
import SerialNumberModal from '../sales/Pages/SalesInvoiceMaster/SerialNumberModal';
import CustomerVerifyModal from '../purchase/Pages/PurchaseInvoiceMaster/CustomerVerifyModal';
import TextareaField from 'components/ui/TextareaField';
import { renderSwitchControl } from 'utils/DynamicFormData';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import { getSerialWiseHistory } from '../../../redux/actions/salesLineDetail';
import { getAdjustedDocs, uploadSalesDocument } from '../../../redux/actions/salesInvoice';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useDaybook, useAccount, useItem } from '../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import useSalesOrderLastDaybook from 'hooks/useSalesOrderLastDaybook';

// Actions
import { getStock } from '../../../redux/actions/salesLineDetail';
// import { getAccount, getAccountById, emptyAccount } from '../../../../../redux/actions/account';
import { getAccount } from '../../../redux/actions/account';
import { getPaymentDaybook, getDaybookById, getDaybook } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../redux/actions/glGroup';
import {
   addSaleInvoice,
   updateSaleInvoice,
   emptySales,
   getPrevAndNext,
   getItemPrice,
} from '../../../redux/actions/salesInvoice';
import { deleteSalesLineItem } from '../../../redux/actions/salesLineItem';
import { getBillTerm } from '../../../redux/actions/billTerm';
import {
   generateEInvoice,
   generateEWayBill,
   cancelEInvoice,
   cancelEWayBill,
} from '../../../redux/actions/ewayBillAndeInvoice';
import { getTransport } from '../../../redux/actions/transport';
import { getVehicle } from '../../../redux/actions/vehicle';
import { getSetupFormat, setupFormatCustomQuery } from '../../../redux/actions/setupFormat';
import { getUsers } from '../../../redux/actions/user';
import { getFinancialYears } from '../../../redux/actions/dashboard';

// utils
import {
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   eBillDateFormat,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getGstRate,
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash } from 'react-icons/fa';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import back from 'assets/img/nfts/back.svg';

import DeleteDialog from '../masters/components/DeleteDialog';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { getPurchaseInvoice } from '../../../redux/actions/purchaseInvoice';
import loaderAnimation from 'assets/img/auth/loding.gif';
import {
   addSaleOrder,
   checkDocNo,
   getSaleOrder,
   getSaleOrderById,
   updateSaleOrder,
} from '../../../redux/actions/salesOrder';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),

      transactionAt: Yup.date()
         .required('Transaction date is required'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number()
         .required('Basic amount is required')
         .min(0, 'Basic amount cannot be negative')
         .test(
            'is-decimal',
            'Amount cannot have more than 2 decimal places',
            (value) => !value || Number.isInteger(value * 100),
         ),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),
            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),
            // .test(
            //    'is-decimal',
            //    'Rate cannot have more than 2 decimal places',
            //    (value) => !value || Number.isInteger(value * 100),
            // ),

            qty1: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .required('Quantity is required')
               .when('processedQty1', (processedQty1, schema) => {
                  if (processedQty1 !== undefined && processedQty1 !== null) {
                     return schema.min(
                        processedQty1,
                        `Quantity 1 cannot be less than already processed quantity (${processedQty1})`
                     );
                  }
                  return schema.min(0, 'Quantity 1 cannot be negative');
               }),

            qty2: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .default(0)
               .when('processedQty2', (processedQty2, schema) => {
                  if (processedQty2 !== undefined && processedQty2 !== null) {
                     return schema.min(
                        processedQty2,
                        `Quantity 2 cannot be less than already processed quantity (${processedQty2})`
                     );
                  }
                  return schema.min(0, 'Quantity 2 cannot be negative');
               }),

            qty3: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .default(0)
               .when('processedQty3', (processedQty3, schema) => {
                  if (processedQty3 !== undefined && processedQty3 !== null) {
                     return schema.min(
                        processedQty3,
                        `Quantity 3 cannot be less than already processed quantity (${processedQty3})`
                     );
                  }
                  return schema.min(0, 'Quantity 3 cannot be negative');
               }),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),

            // salesprice2: Yup.number().default(0).min(0, 'Sales price cannot be negative'),

            // salesprice3: Yup.number().default(0).min(0, 'Sales price cannot be negative'),

            lineNumber: Yup.number()
               .required('Line number is required')
               .positive('Line number must be positive')
               .integer('Line number must be a whole number'),
         }),
      ),
});

const invoiceType = 'salesorder';

const SalesInvoiceForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const { isOpen: isOpenExchangeModal, onOpen: onOpenExchangeModal, onClose: onCloseExchangeModal } = useDisclosure();
   const { isOpen: isOpenVerifyModal, onOpen: onOpenVerifyModal, onClose: onCloseVerifyModal } = useDisclosure();
   const { isOpen: isOpenDeleteModal, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const {
      isOpen: isOpenPrintFormatModal,
      onOpen: onOpenPrintFormatModal,
      onClose: onClosePrintFormatModal,
   } = useDisclosure();
   const { lastSaleDaybook, setSelectedDaybookId: setDaybookId } = useSalesOrderLastDaybook();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   const { daybooks: allDaybook, salesOrderDaybooks: daybookData, paymentDaybooks } = useDaybook();
   const { accounts: accountData, incomeAccounts } = useAccount();
   const { items: itemData } = useItem();
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.salesOrder?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const daybookPaymentData = paymentDaybooks;
   const selectedDaybook = useSelector((state) => state.daybook.single);
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const targetGlGroup = glGroup?.find((group) => group.code === 'K');
   const warehouseList = useSelector((state) => state.warehouse.list);
   const companyData = company;
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const editExchangeData = useSelector((state) => state.sales?.single?.exchange);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);

   const [data, setData] = useState([]);
   const [filedDisabled, setFiledDisabled] = useState(false);
   const [invoiceImages, setInvoiceImages] = useState([]);
   const [shouldFetch, setShouldFetch] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   const transportList = useSelector((state) => state.transport?.list);
   const vehicleList = useSelector((state) => state.vehicle?.list);
   const prints = useSelector((state) => state.setupPrint.list);
   const salesManList = useSelector((state) => state.users.users || []);
   const [salesData, setSalesData] = useState(null);
   const [showSalesDetails, setShowSalesDetails] = useState(false);
   const [savedSalesId, setSavedSalesId] = useState(null);
   // Add these state variables
   const [shouldOpenModalForWpSettings, setShouldOpenModalForWpSettings] = useState(false);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyIdVehicle = userGlobalSettingsData?.[0]?.askCompany?.vehicle || false;
   const shouldSendCompanyIdTransport = userGlobalSettingsData?.[0]?.askCompany?.transport || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: null,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,
         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,
         stock: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,
         // subHSNId: null,
         warehouseId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
      };
   }, [company?.hsndata, company?.sacdata]);

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   // const [selectedAccount, setSelectedAccount] = useState(null);
   // const [hasFetchedAccount, setHasFetchedAccount] = useState(false);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [isSameState, setIsSameState] = useState(null);
   const [paymentData, setPaymentData] = useState([]);
   const [exchangePayments, setExchangePayments] = useState([]);
   const [exchange, setExchange] = useState([]);
   const [voucher, setVoucher] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const [currentLineItemIdx, setCurrentLineItemIdx] = useState(null);
   const [isEWayBill, setIsEWayBill] = useState(false);
   const [isEInvoice, setIsEInvoice] = useState(false);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);

   const [row, setRow] = useState({
      header: {
         daybookId: lastSaleDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         notes: '',
         vehicleId: null,
         transportId: null,
         representativeId: user?.id,
         incomeId: null,
      },
      lineItem: [initialLineItem],
   });

   const { id } = useParams();
   const toast = useToast();
   const dispatch = useDispatch();
   const darkMode = useColorModeValue(false, true);
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();

   const newDaybookId =
      salesData && salesData.daybookId !== undefined && salesData.daybookId !== null ? salesData.daybookId : null;

   const shouldShowSalesDetails = newDaybookId === row.header.daybookId && salesData?.wpSetting === 0;

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
      invoiceType,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   // Create refs for each input field
   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const incomeRef = useRef(null);
   const brokerRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const transportRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const exchangeRef = useRef(null);
   const cancelewaybillRef = useRef(null);
   const generateewaybillRef = useRef(null);
   const canceleinvoiceRef = useRef(null);
   const geberateeinvoiceRef = useRef(null);
   const vehicleRef = useRef(null);
   const notesRef = useRef(null);
   const supplierRef = useRef(null);
   const wareHouseRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const subamountRefs = useRef([]);
   const paymentRefs = useRef([]);
   const exchangeData = useRef({ exchanges: [], exchangePayments: [] });
   const refs = {
      warehouseRef,
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 3).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (id && salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (id && salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (id && salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [id, salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const exchangeDaybook = useMemo(() => {
      return allDaybook?.find((daybook) => daybook.name.toUpperCase() === 'PURCHASE EXCHANGE');
   }, [allDaybook]);

   const vouchers = useMemo(() => salesInvoice?.vouchers ?? [], [salesInvoice?.vouchers]);

   useEffect(() => {
      const saleInvoiceRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.saleinvoice
         : null;

      if (user && !user?.isAdmin) {
         if (window.location.pathname.includes('sales/invoice/add') && saleInvoiceRight) {
            if (saleInvoiceRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('sales/invoice/edit') && saleInvoiceRight) {
            if (saleInvoiceRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.sales_invoice) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      if (user && user.isExpired) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            if (!isLoading) {
               handleAskToVerifyCustomerForSales();
            }
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [row, isLoading]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         .fill()
         .map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         .fill()
         .map((_, i) => amountRefs.current[i] || createRef());
   };

   const preparePaymentRowRefs = (count) => {
      paymentRefs.current = Array(count)
         .fill()
         .map((_, i) => paymentRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   const handleStockModalOnClick = useCallback(
      async (index) => {
         const lineItemData = row.lineItem[Number(index)];
         const selectedItem = itemData?.find((item) => item.id.toString() === lineItemData?.itemId?.toString());
         if (selectedItem?.itemdetailtype === 1) {
            if (user?.loginhistory?.companyId)
               await dispatch(
                  getStock({
                     itemId: Number(lineItemData?.itemId),
                     companyId: Number(user?.loginhistory?.companyId),
                     isReceiveStock: false,
                  }),
               );
            setStockList((prev) => prev.concat(lineItemData?.stock));
            onOpenModal();
         }
      },
      [dispatch, itemData, onOpenModal, row.lineItem, user?.loginhistory?.companyId],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };

      setDaybookId(Number(value));
      await dispatch(
         getBillTerm({
            daybookId: Number(value),
            ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
         }),
      );

      newRow.header[name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = useCallback(
      async (name, value) => {
         if (name === 'accountId') {
            const newRow = { ...row };
            const id = typeof value === 'object' && value !== null ? value.id : value;

            newRow.header[name] = id;
            setRow(newRow);

            setErrors((prev) => {
               const obj = { ...prev };
               delete obj['header.accountId'];
               return obj;
            });
         }

         if (name === 'warehouseId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            newRow.lineItem = newRow.lineItem.map((item) => ({
               ...item,
               [name]: value,
               stock: Array.isArray(item.stock)
                  ? item.stock.map((stockItem) => ({
                     ...stockItem,
                     [name]: stockItem.warehouseId ? stockItem.warehouseId : value,
                  }))
                  : [], // fallback if stock is not array
            }));
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'brokerId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'transportId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.transportId'];
               return obj;
            });
         }

         if (name === 'vehicleId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.vehicleId'];
               return obj;
            });
         }

         if (name === 'representativeId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.representativeId'];
               return obj;
            });
         }

         if (name === 'incomeId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.incomeId'];
               return obj;
            });
         }
      },
      [row],
   );

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData?.find((item) => item.id.toString() === itemId.toString());
         if (selectedItem && selectedItem.itemdetailtype === 1) {
            onOpenModal();
         }
      },
      [itemData, onOpenModal],
   );

   const handleItemPrice = useCallback(
      async (itemId, type) => {
         if (daybook?.partyItemWiseLastRate || daybook?.itemWiseLastRate) {
            const params = { itemId, companyId: company?.id, type };
            if (daybook?.partyItemWiseLastRate) {
               params.accountId = account?.id;
            }
            const res = await dispatch(getItemPrice(params));
            return res?.data?.itemPrice ?? '';
         }
      },
      [account?.id, company?.id, daybook?.itemWiseLastRate, daybook?.partyItemWiseLastRate, dispatch],
   );

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         // const itemRate = Number(value || 0);
         // const gstPercent = Number(newRow[header][idx].gst || 0);
         // const gstRate = itemRate * (1 + gstPercent / 100);
         const gstRate = getGstRate(value, newRow, header, idx);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      const daybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      if (name === 'itemId') {
         const selectedItem = itemData.find((x) => x.id === Number(value));

         newRow[header][idx].unit = selectedItem?.ratepersalesid;
         setCurrentLineItemIdx(idx);
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, 'salesorder');
         if (selectedItem?.salesprice1) {
            const gstRate = getGstRate(selectedItem?.salesprice1, newRow, header, idx);
            newRow[header][idx].gstWithRate = gstRate;
         }
         const itemPrice = await handleItemPrice(value, 'sales');
         const rate = getGstRate(itemPrice, newRow, header, idx);
         newRow[header][idx].gstWithRate = rate;
         handleRateChange('itemRate', itemPrice, idx);
         await dispatch(
            getStock({
               itemId: Number(value),
               companyId: user?.loginhistory?.companyId,
               daybookId: daybook?.purchaseDaybookId,
               isReceiveStock: false,
            }),
         );
         newRow.lineItem[idx].stock = [];
         handleStockModal(value, idx);
      }

      let subHsn;
      if (company?.setting?.applyGST && daybook?.applyGst && newRow[header][idx].itemId) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.sacData?.subHsn?.length === 1) {
                  subHsn = lineItem?.sacData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const taxRate = parseFloat(subHsn?.gst) / 100;
            newRow[header][idx].gst = subHsn?.gst ?? 0;
            newRow[header][idx].subHSNId = subHsn?.id ?? 0;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            // Get the current basic amount
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;

            // Calculate addition and deduction totals based on the basic amount
            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });

            // Calculate net amount based on the basic amount
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);

            // Update the header amounts
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev.lineItem, { ...initialLineItem }],
      }));
   };

   const removeLineItem = (index, id) => {
      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deleteSalesLineItem(deleteLineItemId));
      if (row.lineItem?.length >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== currentLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      onCloseDeleteModal();
      setCurrentLineItemIdx(null);
   };

   const removeStock = useCallback(
      (stock) => {
         const updatedLineItem = row.lineItem.map((lineItem, idx) => {
            const selectedItem = itemData.find((i) => i.id === lineItem.itemId);
            const stockData = lineItem.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...lineItem, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...lineItem, stock: stockData, qty1: qty1 };
            }

            return lineItem;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, itemData, row.lineItem],
   );

   const handleEditValues = useCallback(async () => {
      if (id && salesInvoice) {
         setRow({
            header: {
               daybookId: salesInvoice.daybookId,
               docno: salesInvoice.docno,
               transactionAt: salesInvoice.transactionAt
                  ? moment(salesInvoice.transactionAt, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : '',
               dueAt: salesInvoice.dueAt ? new Date(salesInvoice.dueAt).toISOString().split('T')[0] : '',
               dueDays: salesInvoice.dueDays,
               accountId: salesInvoice.accountId,
               basicAmount: salesInvoice.basicAmount,
               netAmount: salesInvoice.netAmount,
               notes: salesInvoice.notes,
               transportId: salesInvoice.transportId,
               vehicleId: salesInvoice.vehicleId,
               representativeId: salesInvoice.representativeId,
               brokerId: salesInvoice.brokerId,
               warehouseId: salesInvoice.warehouseId,
               incomeId: salesInvoice.incomeId,
            },
            lineItem:
               salesInvoice.lineitems?.map((item, index) => {
                  if (item?.processedQty1 > 0 || item?.processedQty2 > 0 || item?.processedQty3 > 0) {
                     setFiledDisabled(true);
                  }
                  return {
                     ...item,
                     itemRate: item.itemRate?.toString(),
                     amount: item.amount,
                     typeOfSupply: Number(item.typeOfSupply),
                     netAmount: item.netAmount,
                     taxableAmount: item.taxableAmount,
                     ratio: item.ratio,
                     addLess1Percent: item.addLess1Percent,
                     addLess1Amount: item.addLess1Amount,
                     addLess2Percent: item.addLess2Percent,
                     addLess2Amount: item.addLess2Amount,
                     addLess3Percent: item.addLess3Percent,
                     addLess3Amount: item.addLess3Amount,
                     gst: item.gstPercent,
                     unit: item.ratePer,
                     isDeleted: false,
                     isDisabled: (item?.processedQty1 > 0 || item?.processedQty2 > 0 || item?.processedQty3 > 0) ? true : false,
                     notes: item.notes ? item.notes : '',
                     remarks: item.remarks ? item.remarks : '',
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                     stock:
                        item.salesLineDetail?.map((stock) => {
                           return {
                              ...stock,
                              pcs: stock.quantity1,
                           };
                        }) || [],
                  };
               }) || [],
         });

         // Initialize bill terms even if response has empty array
         let initialBillTerms = [];

         if (salesInvoice.billTerms && salesInvoice.billTerms.length > 0) {
            // If we have bill terms in response
            initialBillTerms = salesInvoice.billTerms.map((billTerm) => ({
               id: billTerm?.id,
               billTermId: billTerm.billTermId,
               percentage: billTerm?.percentage || 0,
               amount: billTerm?.amount || 0,
            }));
         } else if (billTermData && billTermData.length > 0) {
            // If no bill terms in response but we have bill term data loaded
            initialBillTerms = billTermData.map((term) => {
               const billTerm = salesInvoice.salebillterms?.find((billTerm) => billTerm.billTermId === term.id);
               if (billTerm) {
                  return {
                     id: billTerm?.id,
                     billTermId: term.id,
                     percentage: billTerm?.percentage || 0,
                     amount: billTerm?.amount || 0,
                  };
               } else {
                  return {
                     billTermId: term.id,
                     percentage: 0,
                     amount: 0,
                  };
               }
            });
         }

         setBillTerms(initialBillTerms);
      }
   }, [id, salesInvoice, billTermData, setFiledDisabled]);
   // billTermData, dispatch, hasFetchedAccount, id, salesInvoice

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => ({
            ...prev,
            [header]: {
               ...prev[header],
               dueAt: moment().add(Number(value), 'days').format('YYYY-MM-DD'),
            },
         }));
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const dataSave = _.debounce(
      async () => {
         const isValid = await validateForm();

         if (isValid) {
            setIsLoading(true);
            const exchangesData = exchange?.length > 0 ? exchange : exchangeData.current.exchanges;
            const exchangePaymentData =
               exchangePayments?.length > 0 ? exchangePayments : exchangeData.current.exchangePayments;

            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  docno: row.header?.docno?.toString()?.trim(),
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  // voucherId: voucher,
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  daybookId: Number(row.header.daybookId),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  transactionAt: moment(row.header.transactionAt).format('YYYY-MM-DD'),
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  warehouseId:
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                           : row.header.warehouseId
                        : null,
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  gstTxnType: getGstTaxType(company, account, 'sales'),
                  gstSubTxnType: getGstSubTaxType(company, account, 'sales'),
                  assesseType: companyList?.assesseType ? companyList?.assesseType : 0,
                  distance: companyList?.distanceKM ? companyList?.distanceKM : 0,
                  brokerId: row.header.brokerId || null,
                  notes: row.header.notes || null,
                  transportId: row.header.transportId || null,
                  vehicleId: row.header.vehicleId || null,
                  representativeId: row.header.representativeId || null,
                  incomeId: row.header.incomeId || null,
               },
               lineItems: row.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());

                  const finalWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                              : item.warehouseId
                           : null;

                  const finalStockWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                              : item.warehouseId
                           : companyData?.setting?.warehouseWishStock === true && lineDetailview === true
                              ? item.warehouseId === null
                                 ? (selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1)
                                 : item.warehouseId
                              : null;

                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,
                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem?.ratepersalesid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1) : 0,
                     qty2: item.qty2 ? Number(item.qty2) : 0,
                     qty3: item.qty3 ? Number(item.qty3) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     stock:
                        item.stock?.length > 0
                           ? item.stock.map((s) => ({
                              ...s,
                              itemId: item.itemId,
                              warehouseId: s.warehouseId ? s.warehouseId : finalStockWarehouse,
                              returnStatus: undefined,
                              warehouseName: undefined,
                           }))
                           : [],
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     // subHSNId: item.subHSNId ?? null,
                     warehouseId: finalWarehouse,
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                     isDisabled: undefined,
                  };
               }),
               billTerms: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
            };

            let res;
            if (id) {
               res = await dispatch(updateSaleOrder(payload));
            } else {
               res = await dispatch(addSaleOrder(payload));
            }

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1 && invoiceImages?.length > 0) {
               const formData = new FormData();
               formData.append('id', res?.data?.id);
               invoiceImages.forEach((imgObj) => {
                  if (!imgObj.isExisting && imgObj.file) {
                     formData.append('bill', imgObj.file);
                  }
               });

               const response = await dispatch(uploadSalesDocument(formData));

               if (response?.code === 1) {
                  setInvoiceImages([]);
               }
            }

            const salesId = res?.data?.header?.id;
            const data = {
               id: salesId,
               type: 'sales',
            };

            let eInvoiceRes;
            let eWayBillRes;
            if (
               daybook?.ewayInvoice &&
               company?.setting?.ewayInvoice &&
               company?.setting?.eInvoiceUserName &&
               company?.setting?.eInvoicePassword &&
               isEInvoice
            ) {
               eInvoiceRes = await dispatch(generateEInvoice(data));
            }
            if (
               daybook?.ewayBill &&
               company?.setting?.ewayBill &&
               company?.setting?.eWayUserName &&
               company?.setting?.eWayPassword &&
               isEWayBill
            ) {
               eWayBillRes = await dispatch(generateEWayBill(data));
            }
            if (eInvoiceRes?.code === 2 || eWayBillRes?.code === 2) {
               setIsLoading(false);
               navigate(`/admin/sales/order/edit/${salesId}`);
               return;
            }
            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }
               // ✅ CAPTURE THE COMPLETE SAVED DATA
               setSalesData(res.data);
               setSavedSalesId(salesId);

               if (daybook?.onlinePrinting) {
                  if (daybook?.askBeforePrint) {
                     // ✅ OPEN MODAL FIRST - BEFORE SHOWING CONFIRMATION
                     // setShouldOpenModalForWpSettings(true);

                     Swal.fire({
                        title: 'Do you want to Print Document?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        cancelButtonColor: '#d33',
                        confirmButtonColor: '#3085d6',
                     }).then(async (result) => {
                        if (result.isConfirmed) {
                           setShouldOpenModalForWpSettings(true);
                           if (daybook?.printingSettings === 0) {
                              setIsLoading(false);
                              handleFormClose();
                              const resp = await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Sales Invoice',
                                 }),
                              );
                              if (resp?.code === 1) {
                                 setShouldOpenModalForWpSettings(false);
                              }
                              const defaultFormat = prints.find((a) => a.isDefault);
                              if (defaultFormat) {
                                 const result = await dispatch(
                                    setupFormatCustomQuery({
                                       query: defaultFormat?.PrintFormat?.query,
                                    }),
                                 );
                                 if (result && result?.data && result?.data?.length > 0) {
                                    const html = injectDataIntoHtml(
                                       defaultFormat?.PrintFormat?.html,
                                       result?.data?.length > 0 ? result?.data : [],
                                    );
                                    // dispatch(emptySales());
                                    // handleReset();
                                    handlePrintClick(
                                       {},
                                       html,
                                       defaultFormat?.PrintFormat?.css,
                                       navigate,
                                       '/admin/sales/order',
                                    );
                                 }
                              }
                           } else {
                              // dispatch(emptySales());
                              // handleReset();
                              setShouldOpenModalForWpSettings(true);
                              onOpenPrintFormatModal();
                           }
                           handleFormClose();
                           // navigate('/admin/sales/order');
                        }

                        if (result.isDismissed) {
                           if (daybook.sendWhatsApp && daybook.wpSettings === 1) {
                              const resp = await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Sales Invoice',
                                 }),
                              );
                              setShouldOpenModalForWpSettings(true);
                           } else {
                              handleFormClose();
                              handleReset();
                              navigate('/admin/sales/order');
                           }
                           // navigate('/admin/sales/order');
                           setIsLoading(false);
                           // ✅ Always run AFTER Swal closes (Yes or No)
                           // handleFormClose();
                           // navigate('/admin/sales/order');
                        }
                     });

                     return;
                  }
               }

               // ✅ SHOW SALES DETAILS AND CLOSE FORM
               setShowSalesDetails(true);
               handleFormClose();
               handleReset();
               navigate('/admin/sales/order');
            }
            setIsLoading(false);
            return;
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         }
      },
      500,
      { leading: true, trailing: false },
   );

   const handleSubmit = useCallback(async () => {
      setIsLoading(true);
      const now = Date.now();
      if (now - lastClick.current < 1000) {
         return;
      }
      lastClick.current = now;
      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno?.toString()?.trim(),
         companyId: user?.loginhistory?.companyId,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };
      if (id) data.id = Number(id);
      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               setRow(newRow);
               await dataSave();
            }

            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else if (res && res.code === 1 && !res.data?.isError) {
         await dataSave();
      } else {
         setIsLoading(false);
      }
   }, [dataSave, dispatch, id, row, user?.loginhistory?.companyId]);

   const handleFormClose = () => {
      // Refresh the list
      dispatch(
         getSaleOrder({
            page: 1,
            limit: 10,
            companyId: user?.loginhistory?.companyId,
            sortBy: 'id',
            sortOrder: 'desc',
         }),
      );

      // Clear form states but keep important data
      setVoucher(null);
      dispatch(emptySales());

      // Clear localStorage
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');

      // Navigate back to list
      // navigate('/admin/sales/order');
   };

   const handleSelectStock = useCallback(
      (e, stock) => {
         if (e.target.checked) {
            const newStock = {
               itemId: stock.itemId,
               itemName: stock.itemName,
               pcs: stock.pcs,
               serialNo: stock.serialNo,
               serialNo2: stock.serialNo2,
               barcode: stock.barcode,
               warehouseName: stock.warehouseName,
               warehouseId: stock.warehouseId,
               isOld: stock.isOld,
               pinvLineDetailId: stock.daybooktype === 11 ? stock.id : null,
               salesReturnLineDetailId: stock.daybooktype === 6 ? stock.id : null,
            };

            setRow((prevRow) => ({
               ...prevRow,
               lineItem: prevRow.lineItem?.map((item, idx) => {
                  if (currentLineItemIdx === idx) {
                     const isExists = item.stock.some((item) => item.serialNo === stock.serialNo);
                     const stockData = isExists ? item.stock : [...item.stock, newStock];
                     handleQtyChange('qty1', stockData?.length, idx);
                     return { ...item, stock: stockData, qty1: stockData?.length };
                  }
                  return item;
               }),
            }));
         } else {
            setRow((prevRow) => ({
               ...prevRow,
               lineItem: prevRow.lineItem?.map((item, idx) => {
                  if (currentLineItemIdx === idx) {
                     const stockData = item.stock.filter((a) => a.serialNo.toString() !== stock.serialNo.toString());
                     handleQtyChange('qty1', stockData?.length, idx);
                     return { ...item, stock: stockData, qty1: stockData?.length };
                  }
                  return item;
               }),
            }));
         }
      },
      [currentLineItemIdx],
   );

   const handlePaymentOnChange = useCallback(
      (e, index) => {
         const { name, value } = e.target;
         const newPaymentData = [...paymentData];
         newPaymentData[index][name] = value;
         setPaymentData(newPaymentData);
      },
      [paymentData],
   );

   const handlePayment = useCallback(() => {
      if (daybookPaymentData?.length > 0) {
         const payment = daybookPaymentData?.map((payment) => {
            return { daybookName: payment.name, daybookId: payment.id, account: 0 };
         });
         setPaymentData(payment);
      }
   }, [daybookPaymentData]);

   const handleAskToVerifyCustomer = useCallback(
      async (fields, paymentData) => {
         const isValid = await validateForm();
         setExchange(fields);
         setExchangePayments(paymentData);
         if (isValid) {
            if (fields?.length > 0 && (exchangeDaybook?.isAskToAllow || selectedDaybook?.isAskToAllow)) {
               onOpenVerifyModal();
               return true;
            } else {
               setExchange(fields);
               setExchangePayments(paymentData);
               exchangeData.current = { exchanges: fields, exchangePayments: paymentData };
               handleSubmit();
               // return false;
            }
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
            return false;
         }
      },
      [
         errors,
         exchangeDaybook?.isAskToAllow,
         handleSubmit,
         onOpenVerifyModal,
         selectedDaybook?.isAskToAllow,
         toast,
         validateForm,
      ],
   );

   const handleAskToVerifyCustomerForSales = useCallback(async () => {
      const isValid = await validateForm();

      if (isValid) {
         if (selectedDaybook && selectedDaybook?.isAskToAllow) {
            onOpenVerifyModal();
         } else {
            try {
               const submittedData = await handleSubmit();
               if (submittedData) {
                  setSalesData(submittedData);
               }
            } catch (error) {
               // Handle cancellation gracefully - don't show error for user cancellation
               if (error.message === 'User cancelled document number change') {
               } else {
                  console.error('Submission failed:', error);
               }
            }
         }
      } else {
         toast({
            title: 'Validation Error',
            description: getFirstErrorMessage(errors),
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   }, [errors, handleSubmit, onOpenVerifyModal, selectedDaybook, toast, validateForm]);

   const handleReset = useCallback(async () => {
      const initialRow = {
         header: {
            daybookId: lastSaleDaybook?.daybookId || '',
            docno: '',
            transactionAt: new Date().toISOString().split('T')[0],
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            notes: '',
            vehicleId: null,
            transportId: null,
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getPaymentDaybook({
               isPayment: true,
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
      handlePayment();
      setBillTerms([]);
      await dispatch(emptySales());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, handlePayment, initialLineItem, lastSaleDaybook?.daybookId, shouldSendCompanyIdDaybook, user]);

   const getSalesInvoiceData = useCallback(async () => {
      if (id) {
         try {
            await dispatch(getSaleOrderById(id));
         } catch (error) {
            console.error('Error fetching data:', error);
         }
      }
   }, [dispatch, id]);

   // In your useEffect
   useEffect(() => {
      getSalesInvoiceData();
   }, [getSalesInvoiceData]);

   const getData = useCallback(async () => {
      setIsPageLoading(true);
      if (user && user?.loginhistory?.companyId) {
         // await dispatch(
         //    getAllDaybooks({
         //       type: 5,
         //       companyId: Number(user?.loginhistory?.companyId),
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getPaymentDaybook({
         //       isPayment: true,
         //       companyId: user?.loginhistory?.companyId,
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getAccount({
         //       compId: Number(user?.loginhistory?.companyId),
         //       accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
         //       ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getDaybook({
         //       companyId: Number(user?.loginhistory?.companyId),
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getItem({
         //       companyId: user?.loginhistory.companyId,
         //       sortBy: 'name',
         //       sortOrder: 'asc',
         //       ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(
            getTransport({ ...(shouldSendCompanyIdTransport && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(
            getVehicle({ ...(shouldSendCompanyIdVehicle && { companyIds: user?.loginhistory?.companyId }) }),
         );
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      await dispatch(getUsers());
      setIsPageLoading(false);
   }, [dispatch, user, user?.loginhistory?.companyId]);

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
      // const historyForItem = serialWiseHistory?.[item.itemName]?.[item.serialNo] || [];
      // setData(historyForItem);
      // onOpenSerialhistory();
   };

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data.items
               .filter((subdata) => subdata.item_id === selectedItem.itemId)
               .flatMap((subdata) => subdata.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem, onOpenSerialhistory]);

   useEffect(() => {
      if (shouldFetch && id && salesInvoice) {
         const fetchData = async () => {
            try {
               const response = await dispatch(
                  getAdjustedDocs({
                     companyId: user?.loginhistory?.companyId,
                     spId: id,
                     daybookId: row.header.daybookId,
                     accountId: row.header.accountId,
                     type: 'SALES',
                  }),
               );
               const match = response.data.find((entry) => entry.adj_daybookname === 'PURCHASE EXCHANGE')?.adj_Id;

               // if (match) {
               //    await dispatch(getPurchaseInvoice(match));
               // }
            } catch (error) {
               console.error('Error fetching adjusted docs:', error);
            } finally {
               setShouldFetch(false); // Reset after running
            }
         };

         fetchData();
      }
   }, [
      shouldFetch,
      id,
      user?.loginhistory?.companyId,
      salesInvoice,
      dispatch,
      row.header.daybookId,
      row.header.accountId,
   ]);

   const handleAdjustedDocs = () => {
      setShouldFetch(true); // Triggers useEffect
      const selectedDaybookData = daybookData.filter((item) => item.id === row.header.daybookId);
      setSelectedDaybookData(selectedDaybookData);
      onOpenAdjustedDocs();
   };

   const handleExchange = () => {
      setShouldFetch(true);
      setTimeout(() => {
         onOpenExchangeModal();
      }, 500);
   };

   const handleSalesSave = async () => {
      const res = await dispatch(getPurchaseInvoice(editExchangeData.id));

      const exchangeData =
         res.data.lineitems?.map((item) => {
            return {
               id: item.id,
               isDeleted: false,
               isOld: item.purchaseLineDetail[0]?.isOld,
               itemId: item.purchaseLineDetail[0]?.itemId,
               itemRate: item.itemRate,
               note1: item.notes,
               purchaseId: editExchangeData.id,
               salesLineDetailId: item.purchaseLineDetail[0]?.id,
               serialNo: item.purchaseLineDetail[0]?.serialNo,
               serialNo2: item.purchaseLineDetail[0]?.serialNo2,
            };
         }) || [];

      const payments =
         res.data.vouchers?.map((payment) => {
            return {
               id: payment.id,
               daybookId: payment.daybookId,
               amount: payment.amount,
               outAdjustmentId: payment.outAdjustmentId,
            };
         }) || [];

      setExchange(exchangeData);
      setExchangePayments(payments);
      setTimeout(() => {
         handleAskToVerifyCustomer(exchangeData, payments);
      }, 1000);
   };

   useEffect(() => {
      getData();
   }, [getData]);

   // useEffect(() => {
   //    if (row.header.daybookId || lastSaleDaybook?.daybookId) {
   //       const daybookId = row.header.daybookId ? row.header.daybookId : lastSaleDaybook?.daybookId;
   //       dispatch(
   //          getBillTerm({
   //             daybookId: daybookId,
   //             ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
   //          }),
   //       );
   //    }
   // }, [dispatch, lastSaleDaybook?.daybookId, row.header.daybookId, user?.loginhistory?.companyId]);

   useEffect(() => {
      if (row.header.daybookId || lastSaleDaybook?.daybookId) {
         const daybookId = lastSaleDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastSaleDaybook?.daybookId]);

   // edit data by id
   useEffect(() => {
      getSalesInvoiceData();
   }, [getSalesInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      handleEditValues();
   }, [handleEditValues]);

   // set last sale daybook
   useEffect(() => {
      if (!id) {
         if (lastSaleDaybook && lastSaleDaybook?.docno) {
            const currentDocNo = String(lastSaleDaybook?.docno ?? 0);
            const nextDocNo =
               salesInvoice?.daybookId === lastSaleDaybook?.daybookId
                  ? salesInvoice?.docno
                  : ((parseInt(currentDocNo) + 1).toString() ?? '1');
            // const nextDocNo = (parseInt(currentDocNo) + 1).toString() ?? '1';

            const newRows = { ...row };
            newRows.header.daybookId = lastSaleDaybook.daybookId;
            newRows.header.docno = nextDocNo;

            newRows.lineItem = newRows.lineItem.map((item) => {
               return {
                  ...item,
                  typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
               };
            });
            setRow(newRows);
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  docno: '1',
               },
               lineItem: prev.lineItem?.map((item) => {
                  return {
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  };
               }),
            }));
         }
      }
   }, [daybook?.typeOfSupply, id, lastSaleDaybook?.daybookId, lastSaleDaybook?.docno]);
   // daybook?.typeOfSupply,

   useEffect(() => {
      if (daybookId) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const stocks = row?.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((li) => {
            if (!li.itemId) return [];
            return li.stock;
         });

      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow.lineItem?.map((item) => {
            if (!item.itemId) return { ...item, stock: [] };
            return item;
         }),
      }));

      setSelectedStocks(stocks);
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      setStockList(stocks);
   }, [stocks]);

   useEffect(() => {
      handlePayment();
   }, [handlePayment]);

   useEffect(() => {
      if (row.header.daybookId && user && user?.loginhistory?.companyId) {
         const daybookById = {
            id: Number(row.header.daybookId), // id must be number
            compId: String(user?.loginhistory?.companyId), // compId must be string
         };
         dispatch(getDaybookById(daybookById));
      }
   }, [dispatch, row.header.daybookId, user]);

   useEffect(() => {
      if (!id) {
         if (row.header.daybookId) {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }
      }
   }, [id, row.header.daybookId]);

   useEffect(() => {
      if (row.lineItem?.length > 0) prepareRowRefs(row.lineItem?.length);
   }, [row.lineItem?.length]);

   useEffect(() => {
      if (billTermData?.length > 0) prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   useEffect(() => {
      if (paymentData?.length > 0) preparePaymentRowRefs(paymentData?.length);
   }, [paymentData?.length]);

   useEffect(() => {
      if (!id || vouchers?.length === 0 || daybookPaymentData?.length === 0) return;

      setPaymentData((prevPaymentData) =>
         prevPaymentData.map((payment) => {
            const matchingVoucher = vouchers.find((voucher) => voucher.daybookId === payment.daybookId);
            return {
               ...payment,
               id: matchingVoucher?.id ?? null,
               amount: matchingVoucher?.amount ?? 0,
               outAdjustmentId: matchingVoucher?.outAdjustmentId ?? null,
            };
         }),
      );
   }, [id, vouchers, daybookPaymentData]);

   // useEffect(() => {
   //    const timer = setTimeout(() => {
   //       setIsPageLoading(false);
   //    }, 5000);

   //    return () => clearTimeout(timer);
   // }, [row.header.daybookId]);

   // useEffect(() => {
   //    if (!id) {
   //       if (row.header.daybookId) {
   //          if (daybookRef.current) {
   //             daybookRef.current.focus();
   //          }
   //       }
   //    }
   // }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id && !isPageLoading) {
         const timer = setTimeout(() => {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }, 100);
         return () => clearTimeout(timer);
      }
   }, [id, isPageLoading]);

   const lastDaybookData = daybookData.filter((item) => item.type === 3);

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 3
               ? true
               : false
            : false;

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock && herderview && !id) {
         setRow((prev) => {
            const currentWarehouseId = prev.header?.warehouseId;

            // Only update if warehouseId is null
            if (currentWarehouseId === null) {
               const fallbackWarehouseId = selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     warehouseId: fallbackWarehouseId,
                  },
               };
            }

            // No update needed
            return prev;
         });
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true || lineDetailview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId === null // checks for null or undefined
                           ? selectdaybookdata?.wareHouseId !== null
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId !== null
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, row.lineItem?.length]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   const filteredDaybooks = daybookData.filter((item) => item.type === 3);
   const daybookbalance = filteredDaybooks.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               // Focus docnoRef if not already focused
               docNoRef.current?.focus();
            } else {
               // If already focused, go back
               handleReset();
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [handleReset]);

   return (
      <>
         <Card
            flexDirection="column"
            w={{ base: '100%', md: '100%', xl: 'calc(100% - 00px)' }}
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex gap={2} alignItems="center">
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }} // Navigate to the previous page
                              style={{ cursor: 'pointer' }} // Ensure it's clickable
                           ></img>
                           {id ? 'Update' : 'Add'} Sale Order
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance: ₹{Math.abs(daybookbalance)?.toFixed(2)})
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    lastDaybookData,
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       disabled: filedDisabled,
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 5,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 <InputField
                                    ref={docNoRef}
                                    type="text"
                                    name="docno"
                                    label="Document Number"
                                    value={row.header.docno}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={async (e) => {
                                       if (e.key === 'PageUp') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastSaleDaybook?.id)
                                                navigate(`/admin/sales/order/edit/${lastSaleDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.prev) {
                                                navigate(`/admin/sales/order/edit/${res.prev}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/sales/order/add`);
                                             }
                                          }
                                          return;
                                       }
                                       if (e.key === 'PageDown') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastSaleDaybook?.id)
                                                navigate(`/admin/sales/order/edit/${lastSaleDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.next) {
                                                navigate(`/admin/sales/order/edit/${res.next}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/sales/order/add`);
                                             }
                                          }
                                          return;
                                       }
                                       handleKeyDown(e, transactionAtRef, daybookRef);
                                    }}
                                    autoFocus={id > 0 ? true : false}
                                 />
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Grid
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%"
                                       gap={5}>
                                       <Flex gap={5} justifyContent="space-between">
                                          {account.mobile ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={phone}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Phone Icon"
                                                />
                                                {account.mobile}
                                             </GridItem>
                                          ) : null}

                                          {account.email ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Email}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Email Icon"
                                                />
                                                {account.email}
                                             </GridItem>
                                          ) : null}

                                          {account.panNo ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={panno}
                                                   alt="editicon"
                                                   boxSize="22px"
                                                   mr={2}
                                                   title="Pan no Icon"
                                                />
                                                {account.panNo}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                       <Flex gap={5} alignItems="start">
                                          {account.addressJson?.length > 0 ? (
                                             <GridItem display="flex" alignItems="center" maxHeight="50%">
                                                <Image
                                                   src={map}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Billing address Icon"
                                                />
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index}>{address.address1}</Text>
                                                ))}
                                             </GridItem>
                                          ) : null}

                                          <Grid gap={5}>
                                             {account.gstRegNo ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={gstno}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="gst Icon"
                                                   />
                                                   {account.gstRegNo}
                                                </GridItem>
                                             ) : null}
                                             {account.brokername ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Brokername}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Broker name Icon"
                                                   />
                                                   {account.brokername}
                                                </GridItem>
                                             ) : null}

                                             {account.amt ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Balance}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Balance Icon"
                                                   />
                                                   {account.amt}
                                                </GridItem>
                                             ) : null}
                                          </Grid>
                                       </Flex>
                                    </Grid>
                                 ) : null}
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => {
                                       let value = e.target.value; // yyyy-mm-dd

                                       const parts = value.split('-');
                                       if (parts[0]?.length > 4) {
                                          parts[0] = parts[0].slice(0, 4);
                                          value = parts.join('-');
                                       }
                                       handleInputChange('header', {
                                          target: {
                                             name: e.target.name,
                                             value,
                                          },
                                       });
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    isDisabled={filedDisabled}
                                    // disabled={filedDisabled}
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="salesdaybook"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       preRef: accountRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       preRef: brokerRef,
                                       onKeyDown: (e) => {
                                          e.preventDefault();
                                          if (daybook?.isAskIncomeExpenses) {
                                             handleKeyDown(e, incomeRef, brokerRef);
                                             return;
                                          }
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             if (
                                                companyData?.setting?.warehouseWishStock === true &&
                                                (lineitemview === true || lineDetailview === true)
                                             ) {
                                                warehouseRef?.current[0]?.focus();
                                             } else {
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>

                              {daybook?.isAskIncomeExpenses ? (
                                 <GridItem w="100%">
                                    <AccountSelect
                                       ref={incomeRef}
                                       name="incomeId"
                                       options={incomeAccounts}
                                       label="Income Account"
                                       value={row.header.incomeId}
                                       errors={errors}
                                       errorName="header.incomeId"
                                       isClearable
                                       isSearchable
                                       onChange={(value) => {
                                          handleAccount('incomeId', value);
                                       }}
                                       onKeyDown={(e) => {
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             e.preventDefault();
                                             handleKeyDown(e, wareHouseRef, supplierRef);
                                          } else {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       }}
                                       showCustomNoOptions={true}
                                       openfrom="salesdaybook"
                                       glGroup={targetGlGroup}
                                    />
                                 </GridItem>
                              ) : null}

                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (daybook?.isAskIncomeExpenses) {
                                                      incomeRef?.current?.focus();
                                                   } else {
                                                      supplierRef?.current?.focus();
                                                   }
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}
                           </Grid>

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          companyData?.setting?.warehouseWishStock === true && herderview === true
                                             ? wareHouseRef
                                             : daybook?.isAskIncomeExpenses
                                                ? incomeRef
                                                : supplierRef
                                       }
                                       setCurrentLineItemIdx={setCurrentLineItemIdx}
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview === true ? lineitemview : lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                if (refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs?.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, transportRef, dueDaysRef)}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'transportId',
                                          'Transport',
                                          transportList,
                                          {
                                             errorName: 'header.transportId',
                                             value: row.header.transportId,
                                             onChange: (value) => handleAccount('transportId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: transportRef,
                                             nextRef: vehicleRef,
                                             preRef: dueDateRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'transport',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Transport',
                                       )}
                                    </GridItem>
                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'vehicleId',
                                          'Vehicle',
                                          vehicleList,
                                          {
                                             errorName: 'header.vehicleId',
                                             value: row.header.vehicleId,
                                             onChange: (value) => handleAccount('vehicleId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: vehicleRef,
                                             nextRef: notesRef,
                                             preRef: transportRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'vehicle',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Vehicle',
                                       )}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                paymentRefs?.current[0]?.focus();
                                             }
                                             if (e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (vehicleRef?.current) {
                                                      vehicleRef?.current?.focus();
                                                   }
                                                } else {
                                                   paymentRefs?.current[0]?.focus();
                                                }
                                             }
                                          }}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      <Th>Warehouse</Th>
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      selectedStocks?.map((item, index) => {
                                                         return (
                                                            <Tr key={index}>
                                                               <Td>{item.itemName}</Td>
                                                               <Td>
                                                                  {item.serialNo}
                                                                  <Icon
                                                                     as={FaHistory}
                                                                     boxSize={4}
                                                                     ml={3}
                                                                     color="green.600"
                                                                     onClick={() => handleSerialHistory(item)}
                                                                     cursor="pointer"
                                                                  />
                                                               </Td>
                                                               <Td>{item.warehouseName}</Td>
                                                               <Td>
                                                                  <IconButton
                                                                     colorScheme="red"
                                                                     size="sm"
                                                                     onClick={() => removeStock(item)}
                                                                     icon={<FaTrash />}
                                                                  />
                                                               </Td>
                                                            </Tr>
                                                         );
                                                      })}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                          {paymentData?.map((payment, idx) => {
                                             return (
                                                <GridItem w="100%" key={idx}>
                                                   <InputField
                                                      ref={(el) => {
                                                         if (paymentRefs && paymentRefs.current) {
                                                            paymentRefs.current[idx] = el;
                                                         }
                                                      }}
                                                      type="number"
                                                      name={`amount`}
                                                      label={`${payment.daybookName} AMOUNT`}
                                                      value={payment.amount}
                                                      onChange={(e) => handlePaymentOnChange(e, idx)}
                                                      onKeyDown={(e) => {
                                                         if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                         }
                                                         if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }

                                                         if (e.key === 'Tab') {
                                                            e.preventDefault();
                                                            if (e.shiftKey) {
                                                               if (paymentRefs?.current[idx - 1]) {
                                                                  paymentRefs?.current[idx - 1].focus();
                                                               } else {
                                                                  if (notesRef.current) {
                                                                     notesRef.current.focus();
                                                                  }
                                                               }
                                                            } else {
                                                               if (paymentRefs?.current[idx + 1]) {
                                                                  paymentRefs?.current[idx + 1].focus();
                                                               } else {
                                                                  if (submitRef.current) {
                                                                     submitRef.current.focus();
                                                                  }
                                                               }
                                                            }
                                                         }
                                                      }}
                                                      onWheel={(e) => e.target.blur()}
                                                   />
                                                </GridItem>
                                             );
                                          })}
                                       </Grid>
                                    </GridItem>

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       !id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             {renderSwitchControl(
                                                'ewayBill ',
                                                'E-Way Bill ',
                                                {
                                                   isChecked: isEWayBill,
                                                   onChange: (e) => setIsEWayBill(e.target.checked),
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                id ? true : false,
                                             )}
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillno &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillno"
                                                label="E-Way Bill No"
                                                value={salesInvoice?.ewayBillno || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillCanceldate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillCanceldate"
                                                label="E-Way Bill Cancel Date"
                                                value={eBillDateFormat(salesInvoice?.ewayBillCanceldate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillDate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillDate"
                                                label="E-Way Bill Date"
                                                value={eBillDateFormat(salesInvoice?.ewayBillDate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       !id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             {renderSwitchControl(
                                                'ewayInvoice ',
                                                'E-Invoice',
                                                {
                                                   isChecked: isEInvoice,
                                                   onChange: (e) => setIsEInvoice(e.target.checked),
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                id ? true : false,
                                             )}
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackno &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceackno"
                                                label="E-Inv. Ack. No"
                                                value={salesInvoice?.einvoiceackno || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackdate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceackdate"
                                                label="E-Inv. Ack. Date"
                                                value={eBillDateFormat(salesInvoice?.einvoiceackdate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceCancelDate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceCancelDate"
                                                label="E-Inv. Cancel Date"
                                                value={salesInvoice?.einvoiceCancelDate || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceirn &&
                                       id ? (
                                       <GridItem w="100%" colSpan={2}>
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceirn"
                                                label="E-Inv. IRN. No"
                                                value={salesInvoice?.einvoiceirn || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={filteredDaybooks.find((item) => item.id === row?.header?.daybookId)}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form>
                        <CardFooter justifyContent="flex-end" gap={3}>
                           {daybook?.ewayInvoice &&
                              daybook?.applyGst &&
                              company?.setting?.ewayInvoice &&
                              company?.setting?.eInvoiceUserName &&
                              company?.setting?.eInvoicePassword &&
                              id &&
                              salesInvoice?.einvoiceackno == null &&
                              salesInvoice?.einvoiceCancel == null ? (
                              <Button
                                 ref={geberateeinvoiceRef}
                                 colorScheme="green"
                                 onClick={() => {
                                    dispatch(generateEInvoice({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleOrderById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Generate E-Invoice
                              </Button>
                           ) : null}

                           {company?.setting?.eInvoiceUserName &&
                              company?.setting?.eInvoicePassword &&
                              salesInvoice?.einvoiceackno != null &&
                              salesInvoice?.einvoiceCancelDate == null ? (
                              <Button
                                 ref={canceleinvoiceRef}
                                 colorScheme="red"
                                 onClick={() => {
                                    dispatch(cancelEInvoice({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleOrderById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Cancel E-Invoice
                              </Button>
                           ) : null}

                           {daybook?.ewayBill &&
                              daybook?.applyGst &&
                              ((company?.setting?.ewayBill &&
                                 company.setting.eWayUserName != null &&
                                 company.setting.eWayPassword != null &&
                                 salesInvoice?.ewaybillno == null) ||
                                 (salesInvoice?.ewayBillno == null && salesInvoice?.ewayBillCanceldate != null)) ? (
                              <Button
                                 ref={generateewaybillRef}
                                 colorScheme="green"
                                 onClick={() => {
                                    dispatch(generateEWayBill({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleOrderById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Generate E-Way Bill
                              </Button>
                           ) : null}

                           {company?.setting?.eWayUserName &&
                              company?.setting?.eWayPassword &&
                              id &&
                              salesInvoice?.ewaybillno != null &&
                              salesInvoice?.ewayBillCanceldate == null ? (
                              <Button
                                 ref={cancelewaybillRef}
                                 colorScheme="red"
                                 onClick={() => {
                                    dispatch(cancelEWayBill({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleOrderById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Cancel E-Way Bill
                              </Button>
                           ) : null}

                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => {
                                 if (id && editExchangeData?.id) {
                                    handleSalesSave();
                                 } else {
                                    handleAskToVerifyCustomerForSales();
                                 }
                              }}
                              isLoading={isLoading}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 } else if (e.key === 'ArrowLeft' || (e.key === 'Tab' && e.shiftKey)) {
                                    e.preventDefault();
                                    if (
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       id &&
                                       salesInvoice?.ewaybillno != null &&
                                       salesInvoice?.ewayBillCanceldate == null
                                    ) {
                                       cancelewaybillRef.current?.focus();
                                    } else if (
                                       daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       ((company?.setting?.ewayBill &&
                                          company.setting.eWayUserName != null &&
                                          company.setting.eWayPassword != null &&
                                          salesInvoice?.ewaybillno == null) ||
                                          (salesInvoice?.ewayBillno == null &&
                                             salesInvoice?.ewayBillCanceldate != null))
                                    ) {
                                       generateewaybillRef.current?.focus();
                                    } else if (
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackno != null &&
                                       salesInvoice?.einvoiceCancelDate == null
                                    ) {
                                       canceleinvoiceRef.current?.focus();
                                    } else if (
                                       daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       id &&
                                       salesInvoice?.einvoiceackno == null &&
                                       salesInvoice?.einvoiceCancel == null
                                    ) {
                                       geberateeinvoiceRef.current?.focus();
                                    } else if (e.key === 'Tab' && e.shiftKey) {
                                       paymentRefs?.current[paymentData?.length - 1]?.focus();
                                    }
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 handleReset();
                                 navigate('/admin/sales/order');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box>
            </CardBody>
         </Card>

         <CustomerVerifyModal
            isOpen={isOpenVerifyModal}
            onClose={onCloseVerifyModal}
            accountId={row.header.accountId}
            entryData={salesInvoice}
            handleSubmit={handleSubmit}
            mobile={account?.mobile}
            account={account}
            isLoading={isLoading}
            entryType="sales"
            invoiceImages={invoiceImages}
            setInvoiceImages={setInvoiceImages}
         />

         <DeleteDialog
            isDeleteDialogOpen={isOpenDeleteModal}
            setDeleteDialogOpen={onCloseDeleteModal}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Sales Invoice"
            redirect="/admin/sales/order"
         />

         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data?.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data.doc_no}</Td>
                                 <Td>{new Date(data.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data.transaction_type}</Td>
                                 <Td>{data.account_name}</Td>
                                 <Td>{data.daybook_name}</Td>
                                 <Td>{data.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0].name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         {/* {salesData && (
            <SalesDetails
               salesData={salesData}
               setShouldOpenModalForWpSettings={setShouldOpenModalForWpSettings}
               shouldOpenModalForWpSettings={shouldOpenModalForWpSettings}
            />
         )} */}

         {(salesData || shouldShowSalesDetails) && (
            <SalesDetails
               salesData={salesData}
               setShouldOpenModalForWpSettings={setShouldOpenModalForWpSettings}
               shouldOpenModalForWpSettings={shouldOpenModalForWpSettings}
            />
         )}
      </>
   );
};

export default SalesInvoiceForm;
